(async () => {
  const cartData = await (await fetch("/cart.js")).json();

  const hasDiscount = cartData.discount_codes.some(discount_code => {
    return discount_code.code === "K96FPGNTNV"
  })

  document.body.classList.add("discount-checker--loaded");

  document.body.classList.toggle("discount-checker--sale", hasDiscount);
})()

class DiscountApplier extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button')?.addEventListener('click', this.submitHandler.bind(this))
  }

  async submitHandler() {
    const buttonElement = this.querySelector('button');
    buttonElement.classList.add('is--loading');

    const response = await (await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        discount: [...await this.getDiscounts(), "K96FPGNTNV"].join(',')
      })
    })).json();

    await this.checkDiscount()

    buttonElement.classList.remove('is--loading');
  }

  async checkDiscount() {
    const cartData = await (await fetch("/cart.js")).json();

    const hasDiscount = cartData.discount_codes.some(discount_code => {
      return discount_code.code === "K96FPGNTNV"
    })

    document.body.classList.add("discount-checker--loaded");

    document.body.classList.toggle("discount-checker--sale", hasDiscount);
  }

  async getDiscounts(){
    try{
      return (await (await fetch('/cart.json')).json()).discount_codes.map(({code}) => code)
    }catch(error){
      console.error("Error getting cart:", error)
    }
  }
}
customElements.define('discount-applier', DiscountApplier);

